import { create } from "zustand/index";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { WithTypeContaining } from "../../../types/utilityTypes";

export enum PublicAdministrationStatus {
  EMPLOYED = "EMPLOYED",
  NOT_EMPLOYED = "NOT_EMPLOYED",
  UNKNOWN = "UNKNOWN",
}

export type PublicAdministrationState = {
  isPublicAdministrationEmployee: PublicAdministrationStatus;
};

export type PublicAdministrationAction = {
  setPublicAdministration: (
    personalInfoValues: WithTypeContaining<PublicAdministrationState>
  ) => void;
  reset: () => void;
};

const initialState: PublicAdministrationState = {
  isPublicAdministrationEmployee: PublicAdministrationStatus.UNKNOWN,
};

export const usePublicAdministrationStore = create<
  PublicAdministrationState & PublicAdministrationAction
>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setPublicAdministration: (personalInfoValues) => {
          set(publicAdministrationFromForm(personalInfoValues));
        },
        reset: () => set(initialState),
      }),
      {
        name: "public-administration-storage",
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  )
);

const publicAdministrationFromForm = ({
  isPublicAdministrationEmployee,
}: PublicAdministrationState): PublicAdministrationState => ({
  isPublicAdministrationEmployee: isPublicAdministrationEmployee,
});
